<template>
  <div class="ele-body">
    <el-tabs v-model="activeName">
        <el-tab-pane label="短信设置" name="first">
            <el-card shadow="never">
                <el-form ref="form" :model="smsList" label-width="140px">
                    <div class="innerBox">
                        <el-form-item label="appKey：">
                            <el-input v-model="smsList.appkey" class="w-600"></el-input>
                        </el-form-item>
                        <el-form-item label="appSecret：">
                            <el-input v-model="smsList.appsecret" class="w-600"></el-input>
                        </el-form-item>
                        <el-form-item label="sign：">
                            <el-input v-model="smsList.sign" class="w-600"></el-input>
                        </el-form-item>
                        <el-form-item label="template：">
                            <el-input v-model="smsList.template" class="w-600"></el-input>
                        </el-form-item>
                    </div>
                    <div class="innerBoxTo">
                        <el-form-item style="float:right;">
                            <el-button type="primary" @click="submitSms" >提交</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </el-card>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SysUser",
  data() {
    return {

      activeName:'first',
      smsList:{}
    }
  },
  created(){
     this.$http.get('/common/province_list').then(res=>{
          var data=JSON.parse(res.data)
          this.provArr=data
        })
    this.getSms()
  },
  methods:{
    getSms(){
      const loading = this.$loading({lock: true});
      this.$http.get('sms/index').then(res=>{
        loading.close();
        let data=res.data
        this.smsList=data

      })
    },
    submitSms(){
      const loading = this.$loading({lock: true});
      let param={
        appkey:this.smsList.appkey,
        appsecret:this.smsList.appsecret,
        sign:this.smsList.sign,
        template:this.smsList.template
      }
      this.$http.post('sms/editSms',param).then(res=>{
        loading.close();
        let data=JSON.parse(res.data)
        if(data.code==1){
          this.$message({
            message: data.msg,
            type: 'success'
          });
        }else{
          this.$message.error(data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
  },

  computed: {
      ...mapGetters(["permission"]),
  },
  mounted() {
  }
}
</script>

<style scoped>
    .ele-block .el-upload-dragger {
        width: 100%;
    }
    .changeStyle{
        width:150px;margin-right:30px;
    }
    .ele-body{
        padding:15px;
    }
    .el-upload-list el-upload-list--text{display:none !important}
    /deep/.el-tabs__item{
        padding:0 20px !important;
        font-size: 15px;
    }
    /deep/.el-tabs__nav-scroll{
        background: white !important;
        padding-top: 10px;
    }
    .drop-down-first{
        width:150px;
        margin-right:10px;
    }
    .drop-down-second{
       width:150px; 
    }
    .search-margin{
        margin-left: 10px;
    }
    .boxTitle{padding:8px}
    .orderImgBox{margin-left: 10px;height: 80px;}
    .orderImgBox span{ font-size: 36px; }
    .user-info-tabs >>> .el-tabs__nav-wrap {
        padding-left: 20px;
    }
    .innerBox{
        margin-left: 120px;
        padding-top: 20px;
    }
    .innerBoxTo{
        width:60%;
        margin: 0 auto;
        padding-top: 20px;
    }
    .innerTitle{
        font-size: 16px;
        margin-bottom: 20px;
        margin-left: 13px;
    }

</style>

